import EvaluationParametersPeriod from 'models/EvaluationParametersPeriod';

import { ApiLinkEntity, ApiLinkRel } from "config/constants"

import { IApiLink } from "@/types"

import { IEvaluationParametersPeriodDto } from "./EvaluationParametersPeriod"

export interface IGetEvaluationParametersSettingsDto {
    currentPeriod: IEvaluationParametersPeriodDto | null
    isMoreThanOnePeriodExists: boolean
    links?: IApiLink[]
}

export default class EvaluationParametersSettings {
    currentPeriod: EvaluationParametersPeriod | null
    isMoreThanOnePeriodExists: boolean
    linkGetPeriods?: IApiLink
    linkCreatePeriod?: IApiLink
    linkPatchPeriod?: IApiLink
    linkGetEvaluationParameters?: IApiLink

    constructor({
        currentPeriod,
        isMoreThanOnePeriodExists,
        links,
    }: IGetEvaluationParametersSettingsDto) {
        this.currentPeriod =currentPeriod ? new EvaluationParametersPeriod(currentPeriod): null
        this.isMoreThanOnePeriodExists = isMoreThanOnePeriodExists

        if (links) {
            this.linkGetPeriods = links.find(lnk => lnk.entity === ApiLinkEntity.evaluationParametersPeriod && lnk.rel === ApiLinkRel.all)
            this.linkCreatePeriod = links.find(lnk => lnk.entity === ApiLinkEntity.evaluationParametersPeriod && lnk.rel === ApiLinkRel.new)
            this.linkPatchPeriod = links.find(lnk => lnk.entity === ApiLinkEntity.evaluationParametersPeriod && lnk.rel === ApiLinkRel.partialUpdate)
            this.linkGetEvaluationParameters = links.find(lnk => lnk.entity === ApiLinkEntity.evaluationParameter && lnk.rel === ApiLinkRel.all)
        }
    }
}
